const MiniFlower = ({ x, y, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <g fill="#C5705D">
      {[0, 60, 120, 180, 240, 300].map((d) => (
        <path key={d} d="M0 -9 C 2 -5, 2 -2.5, 0 0 C -2 -2.5, -2 -5, 0 -9 Z" transform={`rotate(${d})`} />
      ))}
    </g>
    <circle r="2.1" fill="#F4C2A6" />
    <circle r="0.9" fill="#C5705D" />
  </g>
);

const Leaf = ({ x, y, rotate }) => (
  <path
    d="M0 0 C 3.5 -3.5, 8.5 -3.5, 12 0 C 8.5 3.5, 3.5 3.5, 0 0 Z"
    transform={`translate(${x} ${y}) rotate(${rotate})`}
    fill="#C5705D"
    opacity="0.85"
  />
);

export const TalaveraVine = ({ className = "" }) => (
  <svg viewBox="0 0 60 220" className={className} aria-hidden="true" focusable="false">
    <path
      d="M30 8 C 46 34, 14 54, 30 82 C 46 110, 14 130, 30 158 C 46 184, 16 198, 30 212"
      fill="none"
      stroke="#C5705D"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="30" cy="8" r="2.6" fill="#C5705D" />
    <circle cx="30" cy="212" r="2.6" fill="#C5705D" />
    <MiniFlower x={30} y={82} />
    <MiniFlower x={30} y={158} scale={1.15} />
    <Leaf x={38} y={34} rotate={35} />
    <Leaf x={22} y={110} rotate={-145} />
    <Leaf x={38} y={186} rotate={30} />
    <g fill="#C5705D" opacity="0.75">
      <circle cx="14" cy="58" r="1.7" />
      <circle cx="46" cy="132" r="1.7" />
      <circle cx="15" cy="200" r="1.7" />
    </g>
  </svg>
);
